/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./preview-pdf.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./preview-pdf.component";
import * as i3 from "@angular/platform-browser";
import * as i4 from "@angular/material/dialog";
var styles_PreviewPdfComponent = [i0.styles];
var RenderType_PreviewPdfComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PreviewPdfComponent, data: {} });
export { RenderType_PreviewPdfComponent as RenderType_PreviewPdfComponent };
export function View_PreviewPdfComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "iframe", [["height", "100%"], ["width", "100%"]], [[8, "src", 5]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.url; _ck(_v, 0, 0, currVal_0); }); }
export function View_PreviewPdfComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-preview-pdf", [], null, null, null, View_PreviewPdfComponent_0, RenderType_PreviewPdfComponent)), i1.ɵdid(1, 114688, null, 0, i2.PreviewPdfComponent, [i3.DomSanitizer, i4.MAT_DIALOG_DATA], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PreviewPdfComponentNgFactory = i1.ɵccf("app-preview-pdf", i2.PreviewPdfComponent, View_PreviewPdfComponent_Host_0, {}, {}, []);
export { PreviewPdfComponentNgFactory as PreviewPdfComponentNgFactory };
